import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { Select, Spin } from "antd";
import dayjs from "dayjs";

import Table from "../../../core/pagination/datatable";
import { getApiBaseUrl, GET_REPLACEMENT_LIST } from "../Config/Config";
const { Option } = Select;

const ReplacementList = () => {
  const [replacementList, setReplacementList] = useState([]);
  const [replacementLoading, setReplacementLoading] = useState(true);
  const [replacementError, setReplacementError] = useState(null);
  // const user = JSON.parse(sessionStorage.getItem("user"));
  const [selectedBlock, setSelectedBlock] = useState(0);
  const [blocks, setBlocks] = useState([]);
  // Function to fetch replacement list
  // FLT2035\

  useEffect(() => {
    const fetchBlocks = async () => {
      try {
        const response = await fetch(`${getApiBaseUrl()}/api/getLocationType`);
        const result = await response.json();
        if (result?.ResultData && result?.ResultData?.length > 0) {
          setBlocks(result?.ResultData);
          // setSelectedBlock(result?.ResultData[0].BlockId);
        }
      } catch (err) {
        console.error("Error fetching blocks:", err);
      }
    };
    fetchBlocks();
  }, []);

  const handleBlockChange = (blockId) => {
    setSelectedBlock(blockId);
  };
  const fetchReplacementList = async () => {
    setReplacementLoading(true);

    try {
      const response = await fetch(
        `${getApiBaseUrl()}${GET_REPLACEMENT_LIST}?BlockId=${selectedBlock}&Barcode=0`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Set ResultData or fallback to empty array
      setReplacementList(
        Array.isArray(data?.ResultData) ? data.ResultData : []
      );
    } catch (err) {
      setReplacementError(err.message || "Something went wrong");
    } finally {
      setReplacementLoading(false);
    }
  };

  // Call fetchReplacementList on component mount
  useEffect(() => {
    fetchReplacementList();
  }, [selectedBlock]);

  console.log(replacementList, replacementLoading, replacementError);

  const columns = [
    {
      title: "Old Filter ID",
      dataIndex: "OldLable",
      key: "OldLable",
      sorter: (a, b) => a?.OldLable?.length - b?.OldLable?.length,
    },
    {
      title: "New Filter ID",
      dataIndex: "Lable",
      key: "Lable",
      // sorter: (a, b) => a.AHUcode - b.AHUcode,
    },

    // {
    //   title: "Location",
    //   dataIndex: "locatinname",
    //   key: "locatinname",
    //   sorter: (a, b) => a.locatinname.localeCompare(b.locatinname),
    // },
    {
      title: " User ID",
      dataIndex: "UserName",
      key: "UserName",
      sorter: (a, b) => a.UserName.localeCompare(b.UserName),
    },
    // {
    //   title: "Status",
    //   dataIndex: "StageName",
    //   key: "StageName",
    //   render: (text) => <span className="badge bg-danger">{text}</span>,
    // },
    // {
    //   title: "Last Change",
    //   dataIndex: "LastCleaningDate",
    //   key: "LastCleaningDate",
    //   sorter: (a, b) =>
    //     new Date(a.LastCleaningDate) - new Date(b.LastCleaningDate),
    //   render: (value) => (value ? dayjs(value).format("DD/MM/YYYY") : ""),
    // },
    {
      title: "Replaced Date",
      dataIndex: "ReplacedOn",
      key: "ReplacedOn",
      sorter: (a, b) => new Date(a.ReplacedOn) - new Date(b.ReplacedOn),
      render: (value) => (value ? dayjs(value).format("DD/MM/YYYY") : ""),
    },

    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      sorter: (a, b) => a.remarks.localeCompare(b.remarks),
      render: (text) => (
        <span title={text}>
          {text?.length > 15 ? `${text.slice(0, 15)}...` : text}
        </span>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Replacement List
                  </h4>
                </ol>
              </nav>
              <h6>Find replaced filters below </h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li></li>
          </ul>
        </div>
        {/* <div className="row mb-2">
          {blocks.map((block, index) => (
            <div className="col-auto mb-2" key={index}>
              <button
                className={`btn ${
                  activeBlock === block
                    ? "btn-primary"
                    : "btn-light border-primary text-primary"
                }`}
                onClick={() => setActiveBlock(block)}
                type="button"
              >
                {block}
              </button>
            </div>
          ))}
        </div> */}
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
            <div className="search-set m-3"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div style={{ minWidth: "250px" }}>
                <label className="fw-bold mb-1 d-block">Select Block:</label>
                <Select
                  style={{ width: "100%" }}
                  value={selectedBlock === 0 ? 0 : selectedBlock} // Ensures "All" is shown when value is 0
                  onChange={handleBlockChange}
                  placeholder="Select Block"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  <Option value={0}>All</Option>
                  {blocks.map((block) => (
                    <Option key={block.BlockId} value={block.BlockId}>
                      {block.BlockName}
                    </Option>
                  ))}
                </Select>
              </div>

              {/* <div className="dropdown me-2">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Category
                </Link>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      HEPA
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Pre-Filter
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Bag Filter
                    </Link>
                  </li>
                 
                </ul>
              </div> */}
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {replacementLoading ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : replacementList.length > 0 ? (
                <Table columns={columns} dataSource={replacementList} />
              ) : (
                <p className="text-center my-4">No data available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReplacementList;
